var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTermsOfService(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 33,
    viewBox: "0 0 28 33",
    fill: "current",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14 3.65176L24.5 8.18717V15.0413C24.5 21.633 20.03 27.7143 14 29.5226C7.97 27.7143 3.5 21.633 3.5 15.0413V8.18717L14 3.65176ZM14 0.458008L0.5 6.29134V15.0413C0.5 23.1351 6.26 30.7038 14 32.5413C21.74 30.7038 27.5 23.1351 27.5 15.0413V6.29134L14 0.458008ZM12.5 9.20801H15.5V12.1247H12.5V9.20801ZM12.5 15.0413H15.5V23.7913H12.5V15.0413Z",
    fill: "current"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTermsOfService);
export default __webpack_public_path__ + "static/media/terms_of_service.a30f87bb8fa2478916400894fb0851fd.svg";
export { ForwardRef as ReactComponent };